import {
  UICoreNextProvider as _UICoreNextProvider,
  makeLinkComponent,
} from '@simplywallst/ui-core/next';
import type { LegacyRef, ReactNode } from 'react';
import Link from 'redux-first-router-link';
import { isMigratedRoute } from '@simplywallst/next-migrate';
import { useUnleashClient } from '@unleash/proxy-client-react';

const LinkComponent = makeLinkComponent(({ href, children, ...props }, ref) => {
  if (href.startsWith('http'))
    return (
      <a href={href} ref={ref} target="_blank" rel="noreferrer" {...props}>
        {children}
      </a>
    );

  const client = useUnleashClient();

  // Handle migrated routes by forcing them to open with a 'normal' window navigation.
  // This causes the route to be handled by the Next.js proxy server.
  if (
    isMigratedRoute(
      href,
      // If there are no toggles, we can't check if the route is migrated
      // This can occur depending on how the release flags are instantiated.
      client?.getAllToggles()?.length > 0 ? client.isEnabled : () => false
    )
  ) {
    return (
      <a href={href} ref={ref} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link to={href} ref={ref as LegacyRef<Link>} {...props}>
      {children}
    </Link>
  );
});

export const UICoreNextProvider = ({ children }: { children: ReactNode }) => {
  return (
    <_UICoreNextProvider linkComponent={LinkComponent}>
      {children}
    </_UICoreNextProvider>
  );
};
